<template>
  <v-card>
    <v-list-item
        dark
        class="secondary"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-forum
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">
          Messages
          <v-icon dark :color="online ? 'light-green accent-4' : 'grey lighten-2'">mdi-access-point</v-icon>
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <div>
          <v-btn icon @click.prevent="dialog = !dialog">
            <v-icon v-if="!dialog" title="Fullscreen mode">mdi-arrow-expand</v-icon>
            <v-icon v-else title="Exit fullscreen">mdi-arrow-expand</v-icon>
          </v-btn>
          <v-btn icon @click.prevent="minimize = !minimize">
            <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-card-text
        v-if="!minimize && !dialog"
        class="messages-list pa-2"
        ref="messages"
    >
      <messages-list :messages="messages"></messages-list>
      <v-alert v-if="!messages.length" class="text-center grey--text" dense>No messages yet</v-alert>
    </v-card-text>
    <v-alert
        v-if="managerHolidayAlert"
        text
        dense
        color="red"
        icon="mdi-clock-fast"
        class="mb-0"
    >
      Please note that it is a public holiday today, therefore, the application officer's office will not be opened
      today.
    </v-alert>
    <v-card-actions v-if="!minimize && !dialog" class="compose-message">
      <messages-input v-model="newMessage" :loading="loading" @send="send()"/>
    </v-card-actions>
    <v-dialog
        v-model="dialog"
        fullscreen
        scrollable
        hide-overlay
        transition="dialog-bottom-transition"
    >
      <v-card>
        <div>
          <v-toolbar
              dark
              color="secondary"
          >
            <v-icon class="mr-4">
              mdi-forum
            </v-icon>
            <v-toolbar-title>Messages</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            </v-toolbar-items>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </div>
        <v-card-text
            v-if="dialog"
            class="pa-2"
            ref="messages"
        >
          <messages-list :messages="messages"></messages-list>
          <v-alert v-if="!messages.length" class="text-center grey--text" dense>No messages yet</v-alert>
        </v-card-text>
        <v-card-actions v-if="dialog" class="compose-message">
          <messages-input v-model="newMessage" :loading="loading" :rows="6" @send="send()"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import MessagesList from './List'
import MessagesInput from './Input'
import {errorNotification} from "@/components/utils";

export default {
  components: {
    MessagesList,
    MessagesInput
  },
  name: 'ApplicationMessages',
  props: {
    id: Number,
    online: Boolean
  },
  data() {
    return {
      minimize: false,
      messages: [],
      newMessage: {
        body: '',
        is_response_requested: false
      },
      loading: false,
      dialog: false,
      managerHolidayAlert: false,
      managerNotBusinessDayAlert: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ]),
    ...mapGetters(
        {
          currentUsername: 'auth/username'
        }
    )
  },
  filters: {
    formatFromNow(date) {
      return moment(date).fromNow()
    }
  },
  methods: {
    fetchData() {
      this.$axios.get('/applications/' + this.id + '/messages/', {})
          .then((response) => {
            this.messages = response.data
            this.scrollDown()
          })
          .catch((error) => {
            errorNotification(error)
          })
      this.$axios.get('/applications/' + this.id + '/is_manager_holiday/', {})
          .then((response) => {
            this.managerHolidayAlert = response.data.holiday
            this.managerNotBusinessDayAlert = !response.data.business_day
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    send() {
      let message = this.newMessage
      if (message.body.length) {
        this.loading = true
        this.$axios.post('/applications/' + this.id + '/messages/', message)
            .then((response) => {
              this.newMessage = {
                body: '',
                is_response_requested: false
              }
              let message = response.data
              this.messages.push(message)
              this.loading = false
              this.scrollDown()
              // Update unanswered overdue messages total
              this.$root.$emit('fetch-counters')
            })
            .catch((error) => {
              errorNotification(error)
            })
            .finally(() => {
              this.loading = false
            })
      }
    },
    push(message) {
      this.messages.push(message)
      this.scrollDown()
    },
    scrollDown() {
      this.$nextTick(() => {
        this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
      })
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.messages-list {
  overflow-y: auto;
  max-height: 600px;
}

.compose-message {
  border-top: 1px solid #cacaca;
  background: #fefefe;
}
</style>